"use client"

import { usePathname } from "next/navigation"
import { useEffect } from "react"
import { useGlobalConfig } from "@/providers/global-config-context"

/**
 * 条件性脚本加载组件
 * 在停服页面时不加载某些脚本（如快牛客服）
 */
export function ConditionalScripts() {
	const pathname = usePathname()
	useGlobalConfig()

	// 检查是否为停服页面
	const isShutdownPage = pathname.includes("/shutdown")

	// 加载快牛客服脚本
	useEffect(() => {
		// 如果是停服页面，不加载快牛客服脚本
		if (isShutdownPage) {
			return
		}

		// 如果脚本已经存在，不重复加载
		if (document.getElementById("quickcep-chat-script")) {
			return
		}

		// 如果API已经存在，说明已经初始化过了
		if (window.quickChatApi && typeof window.quickChatApi.chat === "function") {
			return
		}

		// 动态创建并注入快牛客服脚本
		const script = document.createElement("script")
		script.id = "quickcep-chat-script"
		script.src = `https://chat.quickcep.com/initQuickChat.js?platform=thers&accessId=${process.env.NEXT_PUBLIC_QUICKCEP_ACCESSID}`
		script.async = true

		// 定义脚本加载失败后的回调
		script.onerror = () => {
			console.error("Failed to load QuickCEP chat script.")
			// 移除失败的脚本，以便可以重试
			document.getElementById("quickcep-chat-script")?.remove()
		}

		document.body.appendChild(script)
	}, [isShutdownPage])

	// 如果是停服页面，不加载任何额外脚本
	if (isShutdownPage) {
		return null
	}
}
